export default __webpack_public_path__ + "static/media/01c_fold-3.3fa88979.mp4";